import { I18n } from '@colonist/i18n';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
export var UIUrlParameterNames = /*#__PURE__*/ function(UIUrlParameterNames) {
    UIUrlParameterNames["EnterMatchmaking"] = "matchmakingqueue";
    UIUrlParameterNames["EnterBotGame"] = "enterbotgame";
    UIUrlParameterNames["VideoAdTesting"] = "bidtest";
    UIUrlParameterNames["Campaign"] = "campaign";
    UIUrlParameterNames["Lobby"] = "lobby";
    UIUrlParameterNames["Spectate"] = "spectate";
    UIUrlParameterNames["MainPage"] = "mainpage";
    UIUrlParameterNames["SelectMode"] = "selectmode";
    UIUrlParameterNames["CreateRoom"] = "createroom";
    UIUrlParameterNames["SuppressPopupsOnLoad"] = "suppresspopupsonload";
    UIUrlParameterNames["DiscordLeaderboard"] = "discordleaderboard";
    UIUrlParameterNames["DiscordStore"] = "discordstore";
    UIUrlParameterNames["DiscordAbout"] = "discordabout";
    UIUrlParameterNames["DiscordCareers"] = "discordcareers";
    UIUrlParameterNames["DiscordChampionship25"] = "discordchampionship25";
    UIUrlParameterNames["DiscordChampionship26"] = "discordchampionship26";
    UIUrlParameterNames["DiscordCommunity"] = "discordcommunity";
    UIUrlParameterNames["DiscordFAQ"] = "discordfaq";
    UIUrlParameterNames["DiscordPrivacyPolicy"] = "discordprivacypolicy";
    UIUrlParameterNames["DiscordPatchNotes"] = "discordpatchnotes";
    UIUrlParameterNames["DiscordProfile"] = "discordprofile";
    UIUrlParameterNames["DiscordGifting"] = "discordgifting";
    UIUrlParameterNames["DiscordValues"] = "discordvalues";
    UIUrlParameterNames["DiscordValuesExamples"] = "discordvaluesexamples";
    UIUrlParameterNames["DiscordTerms"] = "discordterms";
    UIUrlParameterNames["DiscordPressKit"] = "discordpresskit";
    UIUrlParameterNames["DiscordRefundPolicy"] = "discordrefundpolicy";
    UIUrlParameterNames["DiscordMore"] = "discordmore";
    UIUrlParameterNames["DiscordShareActivity"] = "discord-share-activity";
    UIUrlParameterNames["MobileLeaderboard"] = "mobileleaderboard";
    UIUrlParameterNames["MobileLobby"] = "mobilelobby";
    UIUrlParameterNames["MobileHomepage"] = "mobilehomepage";
    UIUrlParameterNames["MobileStore"] = "mobilestore";
    UIUrlParameterNames["MobileProfile"] = "mobileprofile";
    UIUrlParameterNames["MobileMore"] = "mobilemore";
    UIUrlParameterNames["ReferralInvitation"] = "share";
    UIUrlParameterNames["MobileReactivation"] = "mobilereactivation";
    UIUrlParameterNames["MobileImageSharing"] = "mobileimagesharing";
    UIUrlParameterNames["ReconnectGame"] = "reconnectgame";
    return UIUrlParameterNames;
}({});
export class UIUrlController {
    static accessGameFromLink(action) {
        const roomId = this.getRoomIdFromUrl();
        if (roomId == undefined) return;
        action(roomId);
    }
    static getRoomIdFromUrl() {
        if (typeof window.location.hash == 'undefined') return undefined;
        if (window.location.hash == '') return undefined;
        if (!this.isUrlPathRoot()) return undefined;
        const hash = window.location.hash.substr(1, window.location.hash.length);
        const isUrlParameter = Object.values(UIUrlParameterNames).some((param)=>hash.startsWith(param));
        if (isUrlParameter) return undefined;
        return hash === null || hash === void 0 ? void 0 : hash.toLocaleLowerCase();
    }
    static isUrlPathRoot() {
        const requiredFrontAndOptionalTrailingSlashRegex = new RegExp(String.raw`\/${UIUtilsEjsVariables.language}\/?`);
        const pathnameWithoutLanguage = location.pathname.replace(requiredFrontAndOptionalTrailingSlashRegex, '/');
        return pathnameWithoutLanguage == '/' || pathnameWithoutLanguage == '/mobile' || pathnameWithoutLanguage == '/.proxy/discord/web' || pathnameWithoutLanguage == '/.proxy/discord/mobile';
    }
    static extractHashAndValue(href) {
        const hashIndex = href.indexOf('#');
        if (hashIndex == -1 || hashIndex == href.length - 1) return {
            hash: undefined,
            value: undefined
        };
        const hashWithValue = href.slice(hashIndex + 1);
        const splitted = hashWithValue.split('=');
        return {
            hash: splitted[0],
            value: splitted.length > 1 ? splitted[1] : undefined
        };
    }
    static getLanguagePrefix() {
        const languageMappings = new Map([
            [
                'zh',
                'zh-CN'
            ],
            [
                'pt',
                'pt-PT'
            ]
        ]);
        const supportedLanguages = [
            ...I18n.languages,
            ...languageMappings.keys()
        ];
        const pathParts = window.location.pathname.split('/');
        if (pathParts.length < 2) return '';
        const language = pathParts[1];
        if (!supportedLanguages.includes(language)) return '';
        return language;
    }
    static getPathnameWithoutLanguagePrefix() {
        const pathName = window.location.pathname;
        const languagePrefix = this.getLanguagePrefix();
        if (!languagePrefix) return pathName;
        const pathParts = pathName.split('/');
        return '/' + pathParts.slice(2).join('/');
    }
    static getRelativeUrlWithoutLanguagePrefix() {
        const pathName = this.getPathnameWithoutLanguagePrefix();
        const search = window.location.search;
        const hash = window.location.hash;
        return pathName + search + hash;
    }
}
